import React from "react";
import "./whyus.css";
import Threep from "../../../Assets/image/whyUs/why - SEA.jpg";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

const WhyUs = () => {
  const navigate = useNavigate();
  const goToContact = () => {
    navigate("/contact");
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, 100);
  };
  return (
    <>
      <Helmet>
        <title>Why Choose SEA? | India's Most Reliable Solar & IoT Solutions</title>
        <meta name="description" content="Discover why 1000+ farmers and industries trust SEA. We offer 'Made in India' solar controllers with built-in IoT, in-house R&D, and 24/7 remote monitoring support." />
        <meta name="keywords" content="Best solar pump controller India, why choose Sandip electronics , solar IoT benefits, reliable solar inverter Pune, made in India solar automation" />
        <meta property="og:title" content="The SEA Advantage: Why We Are Different" />
        <meta property="og:description" content="From in-house R&D to real-time IoT monitoring, see why SEA is the preferred choice for smart solar automation." />
        <meta property="og:image" content="https://official.seaiot.in/assets/why-choose-us-banner.jpg" />
        <meta property="og:url" content="https://official.seaiot.in/WhyUs" />
        <link rel="canonical" href="https://official.seaiot.in/WhyUs" />
      </Helmet>
      <section className="whyus-wrapper">
        <div className="whyus-container">
          {/* LEFT CONTENT */}
          <div className="whyus-left">
            <h1 className="whyus-title">Why Us ?</h1>

            <div className="stats">
              <div className="stat-box">
                <h3>13</h3>
                <p>Years Of Experience</p>
              </div>
              <div className="stat-box">
                <h3>100%</h3>
                <p>Recommended</p>
              </div>
            </div>

            <p className="description">
              Manufacturer of Solar Pump Controllers in INDIA a Professionally run and operated company. We
              specialize in Manufacturing of Remote Monitoring Systems.
            </p>
            <p className="description">
              We are extremely competitive and understand the value of building
              lifelong relationships with our customers. Once you use us, you
              won’t have to find another company again.
            </p>
            <div className="features">
              <ul>
                <li>Quick response time</li>
                <li>Incredible customer service</li>
                <li>High level of professionalism</li>
                <li>Work completed on time</li>
              </ul>
              <ul>
                <li>Competitive prices</li>
                <li>We understand our customers’ needs</li>
                <li>Latest technology and equipment</li>
                <li>Your property will be treated with care</li>
              </ul>
            </div>
            <p className="cta-text">
              Call us today for a free estimate on any of your Controller remediation
              needs!
            </p>
            <button className="contact-btn" onClick={goToContact}>Contact us</button>
          </div>

          {/* RIGHT IMAGE */}
          <div className="whyus-right">
            <div className="image-box">
              <img
                src={Threep}
                alt="Why choose us"
              />
            </div>
          </div>
        </div>
        <div className="seaMainWrapper">
          {/* Hero */}
          {/* <section className="seaHeroBanner">
            <div className="seaHeroInner">
              <h1 className="seaMainHeadline">Leading Manufacturer of Solar Pump Controllers in India</h1>
              <p className="seaHeroTagline">
                Reliable, High-Efficiency Solar Solutions Powered by 13 Years of Technical Excellence
              </p>
            </div>
          </section> */}

          {/* Why Choose */}
          <section className="seaWhySection">
            <div className="seaContentBox">
              <h2 className="seaWhyHeadline">Why Choose <span className="seaiot-head">SEAIOT</span>?</h2>
              <p className="seaIntroParagraph">
                Are you looking for the best solar pump controller to maximize your agricultural or industrial water flow?
                At SEA IOT, we specialize in engineering high-performance controllers and advanced Remote Monitoring Systems
                (RMS) designed specifically for the Indian climate and terrain.
              </p>

              <div className="seaFeaturesLayout">
                <div className="seaExpertiseBlock">
                  <h3 className="seaExpertiseTitle">Our Expertise</h3>
                  <ul className="seaExpertiseItems">
                    <li><strong>13+ Years &nbsp;</strong> of Industry Experience</li>
                    <li>Specialized &nbsp;<span className="seaRmsHighlight"> Remote Monitoring Systems (RMS)</span></li>
                    <li><span className="seaQualityBadge">100% Recommended Quality</span></li>
                    <li>Customer-Centric Engineering for Indian conditions</li>
                  </ul>
                </div>

                <div className="seaRegionsBlock">
                  <h3 className="seaRegionsTitle">Serving Regions</h3>
                  <div className="seaRegionChips">
                    <span className="seaChipTag">Maharashtra</span>
                    <span className="seaChipTag">Gujarat</span>
                    <span className="seaChipTag">Rajasthan</span>
                    <span className="seaChipTag">Madhya Pradesh</span>
                    <span className="seaChipTag">Jharkhand</span>
                    <span className="seaChipPrimary">All India</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <hr className="seaSectionBreak" />

          {/* Products */}
          <section className="seaProductsArea">
            <div className="seaContentBox">
              <h2 className="seaProductsHeadline color-head">Our Specialized Solar Control Solutions</h2>

              <div className="seaProductTiles">
                <article className="seaProductItem">
                  <h3 className="seaProductHeading seaMpptColor color-mmpt">MPPT Solar Pump Controllers</h3>
                  <p>99% efficiency even in low-light/cloudy conditions</p>
                </article>
                <article className="seaProductItem">
                  <h3 className="seaProductHeading seaRmsColor color-mmpt">IoT-Based Remote Monitoring (RMS)</h3>
                  <p>Real-time data logging via secure cloud portal</p>
                </article>
                <article className="seaProductItem">
                  <h3 className="seaProductHeading seaAtsColor">Automatic Transfer Switch (ATS)</h3>
                  <p>Seamless Solar ↔ Grid power switching</p>
                </article>
              </div>

              <div className="seaComplianceBanner">
                <h3 className="seaComplianceHeading">PM-KUSUM Scheme Compliant</h3>
                <p className="seaComplianceDesc">
                  Our controllers are designed to meet PM-KUSUM Scheme standards, ensuring high-performance reliability for solar water pumping projects across all Indian states..
                </p>
              </div>
            </div>
          </section>
        </div>
      </section>
    </>

  );
};

export default WhyUs;
